import React from "react";
import FollowDesignerButton from "web/react/components/follow-designer-button/follow-designer-button";
import { HStack } from "web/react/emo/h-stack";
import { Text } from "web/react/emo/text";
import { gettext } from "web/script/modules/django-i18n";
import { FeedHeaderSerializer } from "web/types/serializers";

export interface FeedFollowCtaWithDetailsProps {
    profile: FeedHeaderSerializer;
    designerName: string;
}

export function FeedFollowCtaWithDetails({
    profile,
    designerName,
}: FeedFollowCtaWithDetailsProps): React.ReactElement {
    return (
        <HStack spacing="xs" align="center">
            {profile.follow_button && (
                <FollowDesignerButton
                    notFollowedText={gettext("feed.store_updates.cta")}
                    followedText={gettext("feed.following_store_or_brand.label")}
                    analyticsParameters={["du_feed_cta", "click_top_cta", "du_cta"]}
                    lystId={profile.follow_button.lyst_id}
                    isAuthenticated={profile.follow_button.is_authenticated}
                    isFollowing={profile.follow_button.is_following as string}
                    designerName={designerName}
                />
            )}
            {!!profile.followers_count_label && (
                <Text dataTestId="followers_label" as="span" textStyle="body-s" color="secondary">
                    {profile.followers_count_label}
                </Text>
            )}
        </HStack>
    );
}
